import type { ExtendedAdsQueryVariables } from 'src/components/ad/SearchAdsPage';
import type { Props as IconProps } from 'src/components/ui/Icon';
import { GeometrySource } from 'src/types/__generated__/graphql';

export const propertyTypeIcons: Record<string, IconProps['name']> = {
    house: 'HouseGarden',
    apartment: 'Office',
    loft: 'Loft',
    land: 'Land',
    parking: 'Shed',
    other: 'HomeLocation',
};
export const housingTypes = ['house', 'apartment', 'terrain', 'parking', 'loft'];
export const advertiserTypes = ['isPrivateAdvertiser', 'realEstateTradesAdvertiser'];
export const oldOrNewTypes = ['newProperty', 'oldProperty'];
export const defaultListLimit = 12;
export const defaultQueryVariables: ExtendedAdsQueryVariables = {
    offset: 0,
    limit: defaultListLimit,
    orderBy: { createdAt: 'DESC' },
    minPrice: undefined,
    maxPrice: undefined,
    minLandArea: undefined,
    maxLandArea: undefined,
    minLivingArea: undefined,
    maxLivingArea: undefined,
    rooms: undefined,
    bedrooms: undefined,
    house: false,
    apartment: false,
    loft: false,
    parking: false,
    terrain: false,
    newProperty: false,
    oldProperty: false,
    interOffice: false,
    furnished: [],
    type: 'sell',
    assets: undefined,
    isPrivateAdvertiser: false,
    realEstateTradesAdvertiser: false,
    placesSource: GeometrySource.Viewport,
};
